import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  CertificateRegression,
  DataEntityVolumeCertificate
} from 'src/app/Interface/DataEntity/DataEntityVolumeForm_Interface';

@Component({
  selector: 'app-data-entity-volume-certificate-result',
  templateUrl: './DataEntityVolumeCertificateResult.component.html',
  styleUrls: ['./DataEntityVolumeCertificateResult.component.scss']
})
export class DataEntityVolumeCertificateResultComponent {
  @Input() certificate: DataEntityVolumeCertificate | null = null;
  @Input() certificateFilePath: string | null = null;
  @Input() uncertaintyReportFilePath: string | null = null;
  @Input() isDownloading = false;
  @Input() isDownloadingUncertaintyReport = false;
  @Output() download = new EventEmitter<void>();
  @Output() downloadUncertaintyReport = new EventEmitter<void>();

  formatCertificateValue(value: number | string | null | undefined): string {
    if (value === 'Infinity' || value === Number.POSITIVE_INFINITY) {
      return '∞';
    }

    return value === null || value === undefined || value === '' ? '—' : String(value);
  }

  trackByFormula(index: number): number {
    return index;
  }

  trackByValue(index: number): number {
    return index;
  }

  getBooleanStatusLabel(value: boolean | null | undefined): string {
    if (value === true) {
      return 'قابل قبول';
    }

    if (value === false) {
      return 'غیرقابل قبول';
    }

    return 'محاسبه نشده';
  }

  hasRegression(regression: CertificateRegression | null): boolean {
    return regression !== null;
  }
}
